import React, { ReactElement } from 'react';

interface Props {
  width?: string;
  height?: string;
}

const SuccessCheck = (props: Props): ReactElement => {
  const { width, height } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 18 18">
      <path d="M9,0c4.97,0 9,4.03 9,9c0,4.97 -4.03,9 -9,9c-4.97,0 -9,-4.03 -9,-9c0,-4.97 4.03,-9 9,-9Zm0,1.35c-4.225,0 -7.65,3.425 -7.65,7.65c0,4.225 3.425,7.65 7.65,7.65c4.225,0 7.65,-3.425 7.65,-7.65c0,-4.225 -3.425,-7.65 -7.65,-7.65Zm4.527,4.675c0.26,0.254 0.271,0.666 0.03,0.933l-0.019,0.021l-6.113,6.255c-0.256,0.262 -0.672,0.27 -0.939,0.025l-0.02,-0.02l-2.684,-2.683c-0.263,-0.263 -0.263,-0.69 0,-0.954c0.257,-0.257 0.67,-0.264 0.934,-0.02l0.021,0.02l2.2,2.2l5.636,-5.766c0.26,-0.267 0.687,-0.272 0.954,-0.011Z" />
    </svg>
  );
};

SuccessCheck.defaultProps = {
  width: '100%',
  height: '100%',
};

export default SuccessCheck;
